import translator from 'src/translate'
import { withStyles } from '@material-ui/core/styles'
import React, { useState, useRef } from 'react'
import styles from '../styles'
import { useDispatch, useSelector } from 'react-redux'
import { AssignmentFieldNames } from 'src/model/assignment'
import { coursePatchAction } from 'src/reducers/course/action'
import { mediaImageUploadAction } from 'src/reducers/media-image/action'
import { PatchContent, PatchData } from 'src/model/patch'

import { useCourseSettings } from 'src/hooks/useCourseSettings'
import TitleLogo from './components/title-logo'
import { settingsDrawerOpenSuccess } from 'src/reducers/course/action'
import { CoreButton } from 'src/components/core'
const SETTING_KEY = 'general'

const GeneralSettings = props => {
  // `onSaved` replaces the drawer close when the tab is rendered inline.
  const { classes, onSaved } = props
  const entity = useSelector(state => state.course.course)
  const dispatch = useDispatch()
  const { execute, update, exists, value } = useCourseSettings(SETTING_KEY)

  const logoRef = useRef(null)
  const handleDrawerClose = () => {
    if (onSaved) onSaved()
    else dispatch(settingsDrawerOpenSuccess())
  }
  const [assignmentTitle, setAssignmentTitle] = useState(entity?.name || '')
  const [assignmentDescription, setAssignmentDescription] = useState(
    entity?.description || '',
  )

  const [thumbnailUrl, setThumbnailUrl] = useState(entity?.thumbnail || null)

  const [coverPage, setCoverPage] = useState(exists ? value?.coverPage : null)
  const [coverPageText, setCoverPageText] = useState(
    exists ? value.coverPageText : null,
  )

  const [logo, setLogo] = useState(exists ? value.logo : null)

  const onLogoUpload = event => {
    const fileObj = event.target.files && event.target.files[0]
    if (fileObj) {
      dispatch(
        mediaImageUploadAction(fileObj, '', result => {
          setLogo(`${result.url}`)
        }),
      )
    }
  }

  const handleClickAddLogo = () => {
    // 👇️ open file input box on click of other element
    logoRef.current.click()
  }

  const handleSaveCourse = () => {
    const variables = {
      logo: logo,
      coverPage: coverPage,
      coverPageText: coverPageText,
    }

    if (!exists) {
      // create a setting entity with execute function
      execute(variables, {})
    } else {
      update(variables, {})
    }

    const patchSource = new PatchData(null, entity[AssignmentFieldNames.ID])
    patchSource.addContent(
      new PatchContent(
        assignmentTitle,
        AssignmentFieldNames.NAME,
        PatchData.OPERATION_REPLACE,
      ),
    )
    patchSource.addContent(
      new PatchContent(
        assignmentDescription,
        AssignmentFieldNames.DESCRIPTION,
        PatchData.OPERATION_REPLACE,
      ),
    )

    patchSource.addContent(
      new PatchContent(
        thumbnailUrl,
        AssignmentFieldNames.THUMBNAIL,
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(
      coursePatchAction(patchSource, () => {
        handleDrawerClose()
      }),
    )
  }

  const handleTextFieldChange = e => {
    setAssignmentTitle(e.target.value)
  }
  const handleTextFieldChangeDescription = e => {
    setAssignmentDescription(e.target.value)
  }

  return (
    <div className={classes.content}>
      <div className={classes.root__bg}>
        <TitleLogo
          assignmentTitle={assignmentTitle}
          handleTextFieldChange={handleTextFieldChange}
          logo={logo}
          handleClickAddLogo={handleClickAddLogo}
          onLogoUpload={onLogoUpload}
          setLogo={setLogo}
          logoRef={logoRef}
          assignmentDescription={assignmentDescription}
          handleTextFieldChangeDescription={handleTextFieldChangeDescription}
        />
      </div>
      <div className={classes.bottomButton}>
        <CoreButton
          fullWidth={true}
          color="success"
          size="small"
          variant="contained"
          onClick={handleSaveCourse}
        >
          {translator._('assignment.courseSettings.save')}
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(GeneralSettings)
